import * as MagnoliaConfigActions from './../actions/magnolia-config.actions';

export interface ConfigState {
  optionGroups: any;
  optionsCategories: any;
  settingsCategories: any;
  freeVod: any;
  settingsCtaFilter: any;
}

export const initialState: ConfigState = {
  optionGroups: null,
  optionsCategories: null,
  settingsCategories: null,
  freeVod: null,
  settingsCtaFilter: null,
};

export function reducer(
  state: ConfigState = initialState,
  action: MagnoliaConfigActions.Actions,
): ConfigState {
  switch (action.type) {
    case MagnoliaConfigActions.GET_OPTION_GROUPS_CONFIG_SUCCESS:
      return {
        ...state,
        optionGroups: action.payload,
      };
    case MagnoliaConfigActions.GET_OPTIONS_CATEGORIES_CONFIG_SUCCESS:
      return {
        ...state,
        optionsCategories: action.payload,
      };
    case MagnoliaConfigActions.GET_SETTINGS_CATEGORIES_CONFIG_SUCCESS:
      return {
        ...state,
        settingsCategories: action.payload,
      };
    case MagnoliaConfigActions.GET_FREE_VOD_CONFIG_SUCCESS:
      return {
        ...state,
        freeVod: action.payload,
      };
    case MagnoliaConfigActions.GET_SETTINGS_CTA_FILTER_CONFIG_SUCCESS:
      return {
        ...state,
        settingsCtaFilter: action.payload,
      };
    default:
      return state;
  }
}

export const getOptionGroups = (state: ConfigState) => state.optionGroups;
export const getOptionsCategories = (state: ConfigState) =>
  state.optionsCategories;
export const getSettingsCategories = (state: ConfigState) =>
  state.settingsCategories;
export const getFreeVod = (state: ConfigState) => state.freeVod;
export const getSettingsCtaFilter = (state: ConfigState) =>
  state.settingsCtaFilter;
